import axios from "axios"
import { stringify } from 'query-string'
import { authenticationState } from "./Authentication"

export function requestPost(path, payload, headers = {}) {
    return new Promise((resolve, reject) => {
        axios.post(`${process.env.REACT_APP_BASE_URL_API}${path}`, payload, {
            headers: {
                'Role': authenticationState.role,
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${authenticationState.token}`,
                ...headers
            }
        })
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}

export function requestGet(path, parameter, headers = {}) {
    return new Promise((resolve, reject) => {
        axios.get(`${process.env.REACT_APP_BASE_URL_API}${path}?${stringify(parameter)}`, {
            headers: {
                'Role': authenticationState.role,
                'Authorization': `Bearer ${authenticationState.token}`,
                ...headers
            }
        })
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}

export function requestDelete(path, parameter, headers = {}) {
    return new Promise((resolve, reject) => {
        axios.delete(`${process.env.REACT_APP_BASE_URL_API}${path}?${stringify(parameter)}`, {
            headers: {
                'Role': authenticationState.role,
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${authenticationState.token}`,
                ...headers
            }
        })
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}
